import angular from 'angular';
import ngStorage from 'ngstorage';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import Rx from 'rx';
import {normalizeTimeframe} from '../../common/datetime/date-ranges';
import template from './gamesIndex.jade';
import {fetchFullGameAndCallOnNext} from '../../common/util/game-util.js';

export class GamesIndexController {
  /* @ngInject */
  constructor($q, GamesLimitedResource,GameDevelopersResource,GamesResource, CampaignAnalyticsResource,currentGame,currentGameDeveloper,$filter,$localStorage,currentUser,hideThatProduct) {
    this.GamesLimitedResource = GamesLimitedResource;
    this.GameDevelopersResource = GameDevelopersResource;
    this.CampaignAnalyticsResource = CampaignAnalyticsResource;
    this.currentGame = currentGame;
    this.currentGameDeveloper = currentGameDeveloper;
    this.query = new Rx.Subject();
    this.apiDate = $filter('apiDate');
    this.$localStorage = $localStorage;
    this.gamesOfSelectedGameDeveloper = [];
    this.isAGameDeveloperSelected = false;
    this.setGamesMode = false;
    this.disposables = [];
    this.promises = [];
    this.$q = $q;
    this.hideThatProduct = hideThatProduct;

    this.showGames = true;
    this.gameListMode = false;
    this.routingIconsToShow = {
      analytics: true,
      segments: true,
      campaigns: true,
      marketplace: true,
      settings: true
    };

    currentUser.subscribe(user => {
      if (user) {
        this.user = user;
      }
    });

    this.timeframe = normalizeTimeframe(this.$localStorage.timeframe);

    this.disposables.push(currentGame.subscribe((game) => {
      this.game = game;
      this.updateCampaignAnalyticsQuery();
    }));

    const vm = this;
    this.disposables.push(currentGameDeveloper.subscribe((gameDeveloper) => {
      if(gameDeveloper) {
        this.isAGameDeveloperSelected = true;

        if(this.setGamesMode) {
          this.setGamesOfSelectedDeveloper(gameDeveloper);
        }

        if(this.gamesOfSelectedGameDeveloper[0]) {
          if (vm.user.hasRole(['DEMO'])) {
            fetchFullGameAndCallOnNext(GamesResource, this.currentGame, 1560);
          } else {
            this.currentGame.onNext(this.gamesOfSelectedGameDeveloper[0]);
          }
        }
      }
    }));

    this.disposables.push(currentUser.subscribe((user) => {
      if(user) {
        this.user = user;
        this.hideAcquisitionProduct = this.hideThatProduct.hideAcquisitionProduct(user);

        if(user.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','AGENCY','ADMIN_AGENCY', 'OPERATION_MANAGER'])) {
          this.setGamesMode = true;
          this.activeTab =  'Engagement';
          this.getGames(true);
        } else {
          if(user.hasRole('SELLER_ONLY')) {
            this.activeTab =  'Selling';
            delete this.routingIconsToShow.analytics;
            delete this.routingIconsToShow.campaigns;
            delete this.routingIconsToShow.marketplace;
          } else if(user.hasRole('BUYER_ONLY')) {
            this.activeTab =  'Acquisition';
            delete this.routingIconsToShow.analytics;
            delete this.routingIconsToShow.segments;
            _.pull(this.routingIconsToShow, ['analytics', 'segments']);
          } else {
            this.activeTab =  'Engagement';
          }
          this.getGames(false);
        }
      }
    }));

    this.disposeObservable = (d) => { d.dispose() };
    this.$onDestroy = () => { _.forEach(this.disposables, (d) => this.disposeObservable(d)) };

  }

  setGamesOfSelectedDeveloper(gameDeveloper) {
    this.gamesOfSelectedGameDeveloper = _.filter(this.allGamesOfAllGameDevelopers, (game) => {
      return game.game_developer_id == gameDeveloper.id;
    });
  }

  updateCampaignAnalyticsQuery() {
    this.$localStorage.timeframe = this.timeframe;

    if (!this.game) {
      return;
    }

    let query = {
      game_developer_id: this.game.game_developer_id,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate)
    };

    this.query.onNext(query);
  }

  enrichGames(games, gameDevelopers) {
    _.forEach(games, (game) => {
      this.setPlatformsFlags(game);
      if(gameDevelopers instanceof Array) {
        game.gameDeveloperName = _.chain(gameDevelopers).filter(gd => gd.id === game.game_developer_id).map('company_name').value()[0];
      } else {
        game.gameDeveloperName = gameDevelopers.company_name;
      }
    });
  }

  getGames(getAllGameDevelopers) {
    this.promises = [];
    this.promises.push(this.GamesLimitedResource.getList());

    this.promises.push(getAllGameDevelopers ?
      this.GameDevelopersResource.getList() :
      this.GameDevelopersResource.one(this.user.game_developer_ids[0]).get()
    );

    this.$q.all(this.promises).then(([games, gd]) => {
      if(getAllGameDevelopers) {
        this.allGamesOfAllGameDevelopers = games;
        this.currentGameDeveloper.onNext(gd[0]);
        this.enrichGames(this.allGamesOfAllGameDevelopers, gd);
      } else {
        this.gamesOfSelectedGameDeveloper = games;
        this.currentGameDeveloper.onNext(gd);
        this.enrichGames(this.gamesOfSelectedGameDeveloper, gd);
      }
    });
  }

  setPlatformsFlags(game) {
    _.forEach(game.platforms, (platform) => {
      game['has_platform_' + platform.toLowerCase()] = true;
    });
  }

}

let GamesIndexComponent = {
  template: ($element, $attrs) => { return template; },
  controller: GamesIndexController,
  controllerAs: 'vm',
  bindings: true
};

export default angular.module('app.components.games.index', [
  ngStorage.name,
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name
])
  .component('gamesIndex', GamesIndexComponent);



/** WEBPACK FOOTER **
 ** ./src/components/games/gamesIndex.js
 **/